import { deckMachineRequest } from '../../../services/api';

// The builder panels were written against the builder's session-gated /api/admin/* routes.
// Here every call goes through the aibot super proxy (/api/super/machine/*), which signs it
// with the provisioning key and the acting super's email.
type Method = 'get' | 'post' | 'patch' | 'delete';

const ROUTES: Record<string, Partial<Record<Method, string>>> = {
  '/api/admin/lanes': { get: 'lanes', patch: 'lanes' },
  '/api/admin/models': { get: 'models', post: 'models', patch: 'pricing' },
  '/api/admin/providers': { get: 'keys', post: 'keys', patch: 'keys', delete: 'keys' },
  '/api/admin/providers/health': { get: 'keys/health' },
  '/api/admin/aa-router': { get: 'aa-router' },
};

export interface AdminResponse {
  ok: boolean;
  status: number;
  redirected: boolean;
  json: () => Promise<any>;
}

const respond = (status: number, data: any): AdminResponse => ({
  ok: status >= 200 && status < 300,
  status,
  redirected: false,
  json: async () => data,
});

export async function adminFetch(url: string, init?: { method?: string; body?: string; [k: string]: unknown }): Promise<AdminResponse> {
  const [path, query] = url.split('?');
  const method = (init?.method || 'GET').toLowerCase() as Method;
  const surface = ROUTES[path]?.[method];
  if (!surface) return respond(404, { error: `No aibot route for ${method.toUpperCase()} ${path}` });

  const params = query ? Object.fromEntries(new URLSearchParams(query)) : undefined;
  const body = init?.body ? JSON.parse(init.body) : undefined;
  try {
    const data = await deckMachineRequest(method, surface, body, params);
    if (method === 'get' && data?.available === false) {
      return respond(502, { error: `Builder unavailable (${data.reason || 'unknown'})` });
    }
    return respond(200, data);
  } catch (e: any) {
    const status = e?.response?.status || 502;
    return respond(status, { error: e?.response?.data?.detail || e?.message || 'Request failed' });
  }
}
